import FlagSolidSVG from '../../assets/svg/flag-solid.svg';
export default FlagSolidSVG;
